<template>
	<div id class="itle">
		<div class="iten_title">{{articles.name}}</div>
		<div class="itemdz">
			<div id class="itemimg">
				<img src="../assets/activity_time.png" /> {{articles.detail_age}}
			</div>
			<div id class="itemimg">
				<img src="../assets/activity_dizhi.png" />香山革命纪念馆
			</div>
		</div>

		<div class="itemhtml">
			<img :src="articles.imageurl" />
		</div>
		<div class="itemAudio" v-if="articles.audiourl">
			<div>中文解说</div>
			<img v-if="isPlaying" @click="audioCli" src="../assets/CollectionitemPause.png" />
			<img v-if="!isPlaying" @click="audioCli" src="../assets/CollectionitemMp3.png" />
			<audio ref='audio' :src="articles.audiourl"></audio>
		</div>
		<div class="itemhtmltext">
			<div class>{{articles.description}}</div>
			<div class>{{articles.detail_outward}}</div>
			<div class>{{articles.detail_specification}}</div>
		</div>
		<div class="idcode"><img src="../assets/idcode.jpg"/></div>
		<div class="cpcill">相关藏品</div>
		<div class="exhibititemlist">
			<div class="exhibititemlistim">
				<div class="swiper-tab listme" v-for="item in exhibititemlist" @click="coll(item.itemid)">
					<div class="listmediv">
						<img :src="item.imageurl" />
					</div>

					<div class>{{item.name}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: "PersonalCenter",
		data() {
			return {
				baseUrl: "",
				orderlist: "",
				inde: "10",
				articles: [],
				exhibititemlist: [],
				index: 0,
				itemid: "",
				isPlaying:false
			};
		},
		methods: {
			audioCli() {
				var that = this;
				if(!that.isPlaying) {
					that.$refs.audio.play();
					that.isPlaying = true;
				} else {
					that.$refs.audio.pause();
					that.isPlaying = false;
				}
			},
			coll(e) {
				var that = this;
				that.article(e);
				that.item(e);
			},

			item(e) {
				var that = this;
				wclient.view.showLoading();
				that.$http
					.get(
						that.baseUrl +
						"?ugi=item&action=relatedExhibitItem&moduleid=PORTAL&itemid=" +
						e, {}
					)
					.then(function(res) {
						wclient.view.hideLoading();
						that.exhibititemlist = res.data.exhibititemlist;
					})
					.catch(function(err) {
						console.log(err);
					});
			},
			article(e) {
				var that = this;
				wclient.view.showLoading();
				that.$http
					.get(
						that.baseUrl + "?ugi=item&action=detail&moduleid=PORTAL&itemid=" + e, {}
					)
					.then(function(res) {
						wclient.view.hideLoading();
						that.articles = res.data.item;
					})
					.catch(function(err) {
						console.log(err);
					});
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn/ajax";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://xs.weapi.org/ajax";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn/ajax";
			}
			that.baseUrl = baseUrl;
			var itemid = this.$route.query.itemid;
			this.itemid = this.$route.query.itemid;
			wclient.view.showLoading();

			that.article(itemid);
			that.item(itemid);
		}
	};
</script>

<style scoped>
	.exhibititemlist {
		overflow: hidden;
	}
	
	.exhibititemlistim {
		/*position: absolute;*/
		display: flex;
		overflow-x: auto;
	}
	
	.exhibititemlistim .listme {
		width: 30%;
		margin-right: 20px;
	}
	
	.listme img {
		width: 100%;
	}
	
	.listme div {
		font-size: 14px;
		line-height: 35px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		text-align: center;
	}
	
	.listmediv {
		width: 100px;
		height: 100px;
		border-radius: 10px;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.cpcill {
		font-size: 18px;
		font-weight: 600;
		color: rgba(0, 0, 0, 1);
		line-height: 60px;
	}
	
	.itemhtmltext {
		color: #000000;
		margin-top: 20px;
		padding-bottom: 20px;
		border-bottom: 1px #ee201c solid;
	}
	
	.itemhtmltext div {
		line-height: 30px;
		text-indent: 30px;
	}
	
	.itle {
		width: 90%;
		margin: 0 auto;
		padding: 20px 5%;
		background: white;
	}
	
	.iten_title {
		color: #181818;
		font-size: 18px;
		font-weight: bold;
		color: rgba(24, 24, 24, 1);
	}
	
	.itemhtml {
		width: 100%;
		margin: 0 auto;
	}
	
	.itemhtml>>>p {
		line-height: 30px;
		text-indent: 30px;
		margin: 10px 0;
		color: #000000;
		font-size: 16px;
	}
	
	.itemimg {
		display: flex;
		align-items: center;
		color: #7f7f7f;
		line-height: 30px;
	}
	
	.itemimg img {
		width: 16px;
		margin-right: 3px;
	}
	
	.itemdz {
		margin: 10px 0;
		font-size: 14px;
	}
	
	.itemAudio {
		width: 100%;
		text-align: center;
		margin-top: 10px;
		color: #CF120E;
		font-size: 14px;
	}
	
	.itemAudio img {
		width: 15%;
		margin: 10px auto 0;
	}
	.idcode{
		width: 30%;
		margin: 0 auto;
	}
</style>


// WEBPACK FOOTER //
// src/components/Collectionitem.vue